import React from 'react';
interface CTASectionProps {
  variant?: 'primary' | 'final';
}
export function CTASection({
  variant = 'primary'
}: CTASectionProps) {
  if (variant === 'final') {
    return <div className="my-12 bg-gradient-to-br from-[#1E4D3D] to-[#163a2e] p-8 md:p-12 rounded-xl shadow-2xl text-white" data-id="element-31">
        <h2 className="text-3xl md:text-4xl font-bold mb-6 font-sans" data-id="element-32">
          The Choice Is Yours
        </h2>

        <div className="space-y-4 mb-8 text-white/90 leading-relaxed font-serif" data-id="element-33">
          <p data-id="element-34">You can stay where you are.</p>

          <p data-id="element-35">
            Keep making promises you'll break by 7 PM. Keep waking up at 3 AM
            drowning in shame. Keep watching the distance grow between you and
            the people you love. Keep white-knuckling your way through each
            evening, exhausted and defeated.
          </p>

          <p className="font-bold text-white" data-id="element-36">
            Or you can try something that actually addresses what's really
            wrong: your nervous system needs support, not lectures.
          </p>

          <p data-id="element-37">
            This isn't about being "good enough" or "strong enough." You're
            already both of those things.
          </p>

          <p data-id="element-38">
            This is about giving your body what it's been screaming for so you
            can finally feel calm without needing wine to get there.
          </p>
        </div>

        <div className="text-center mb-6" data-id="element-39">
          <p className="text-yellow-300 font-bold text-lg mb-2" data-id="element-40">
            Limited availability — claim your spot now
          </p>
        </div>

        <a href="https://thegliserastore.com/pages/offer" className="w-full bg-yellow-400 hover:bg-yellow-300 text-gray-900 font-bold py-5 px-8 rounded-lg shadow-lg transition-all hover:scale-[1.02] text-center text-lg uppercase tracking-wide block" data-id="element-41">
          YES, I WANT TO TRY GLISERA RISK-FREE
        </a>

        <p className="text-center text-white/70 text-sm mt-6" data-id="element-42">
          100% Satisfaction Guarantee | Secure Checkout | Discreet Shipping |
          Made in USA
        </p>
      </div>;
  }
  return <div className="my-12 bg-gray-50 p-6 md:p-8 rounded-xl border border-gray-200" data-id="element-43">
      <h2 className="text-2xl md:text-3xl font-bold text-gray-900 mb-6 font-sans" data-id="element-44">
        Don't Wait Like I Did
      </h2>

      <p className="text-gray-700 mb-4 leading-relaxed font-serif" data-id="element-45">
        I wasted three years stuck in that cycle.
      </p>

      <p className="text-gray-700 mb-4 leading-relaxed font-serif" data-id="element-46">
        Three years of broken promises. Three years of 3 AM shame spirals. Three
        years of watching my daughter pull away from me. Three years of feeling
        like a prisoner in my own body.
      </p>

      <p className="text-gray-700 mb-6 leading-relaxed font-serif" data-id="element-47">
        I can't get that time back.
      </p>

      <p className="text-gray-700 mb-6 leading-relaxed font-serif font-bold" data-id="element-48">
        But you? You can start today.
      </p>

      <p className="text-gray-700 mb-6 leading-relaxed font-serif" data-id="element-49">
        Every morning you wake up with that heavy shame is another morning
        stolen from you.
      </p>

      <div className="bg-red-50 border-l-4 border-red-500 p-4 mb-8" data-id="element-50">
        <p className="text-red-800 text-sm md:text-base font-medium" data-id="element-51">
          <span className="font-bold" data-id="element-52">Limited Time:</span> Due to incredibly
          high demand, supply is limited. New inventory sells out within days.
        </p>
      </div>

      <div className="text-center mb-8" data-id="element-53">
        <h3 className="text-xl font-bold text-gray-900 mb-4" data-id="element-54">
          What could one month mean for you?
        </h3>
        <ul className="text-left space-y-2 max-w-2xl mx-auto text-gray-700 font-serif" data-id="element-55">
          <li data-id="element-56">✓ Sleeping through the night without 3 AM panic</li>
          <li data-id="element-57">✓ Waking up clear-headed and shame-free</li>
          <li data-id="element-58">✓ Coming home in the evening and feeling genuinely calm</li>
          <li data-id="element-59">✓ Being fully present with your kids</li>
          <li data-id="element-60">✓ Your daughter looking at you again—really looking at you</li>
          <li data-id="element-61">✓ Feeling like yourself for the first time in years</li>
        </ul>
      </div>

      <a href="https://thegliserastore.com/pages/offer" className="w-full bg-[#1E4D3D] hover:bg-[#163a2e] text-white font-bold py-4 px-6 rounded shadow-lg transition-transform hover:scale-[1.01] text-center text-sm md:text-base uppercase tracking-wide mb-4 block" data-id="element-62">
        CHECK AVAILABILITY NOW
      </a>

      <p className="text-center text-gray-600 text-sm" data-id="element-63">
        30-Day Money-Back Guarantee — If you don't feel a significant reduction
        in cravings within 30 days, return it for a full refund. No questions
        asked.
      </p>
    </div>;
}